var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickPensionUnselected = function SvgTickPensionUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.367,
    cy: 21.43,
    r: 20,
    fill: "#FAFAFA",
    stroke: "#C3C3C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C3C3C3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m10.188 22.614 6.545 6.727L32.55 13.523"
  })));
};
export { SvgTickPensionUnselected as ReactComponent };
export default __webpack_public_path__ + "images/Tick_Pension_Unselected.svg";